window.addEventListener("load", function () {

    var elements = document.getElementsByClassName("btn-generar-liga");

    for (var i = 0; i < elements.length; i++) {
        elements[i].addEventListener('click', generarLiga, false);
    }
    function generarLiga() {
            var boton = this;
            var estado = boton.dataset.estado;
            var junta = boton.dataset.junta;
            var tipo = boton.dataset.tipo;
            var nombre = boton.dataset.nombre;
            var directorio = boton.dataset.directorio;
    	    var storagedirectorio = boton.dataset.storagedirectorio;
            var spinner = document.getElementById('spinner'+nombre);

            if (boton.classList.contains('descargable'))
            {
                var liga = boton.dataset.liga;
                descargarArchivo(liga, nombre);
            }else{
                boton.classList.add('d-none');
                spinner.classList.remove('d-none');
                var token = document.head.querySelector('meta[name="csrf-token"]');
                const formData       = new FormData();

                formData.append('estado', estado);
                formData.append('junta',junta);
                formData.append('tipo',tipo);
                formData.append('nombre',nombre);
                formData.append('directorio',directorio);
                formData.append('storagedirectorio',storagedirectorio);
                formData.append('_token',token.content);

                axios.post(`${base_url}/antecedentes/buscador/generadorliga`, formData, {
                    headers: {
                    'Content-Type': 'multipart/form-data'
                    }
                })
                .then(function (response) {

                    console.log(response.data.liga)
                    boton.classList.remove('d-none');
                    boton.classList.add('descargable');
                    spinner.classList.add('d-none');
                    boton.innerHTML='Descargar';
                    boton.setAttribute('data-liga', response.data.liga);

                    var liga = boton.dataset.liga;
                    descargarArchivo(liga, nombre);
                })
                .catch(function (response) {
                        console.log(response.data.error);
                });
            }
        }

    function descargarArchivo(uri, nombre) {
            var ligaDescarga = document.createElement("a");
            ligaDescarga.download = nombre;
            ligaDescarga.href = uri;
            document.body.appendChild(ligaDescarga);
            ligaDescarga.click();
            document.body.removeChild(ligaDescarga);
            ///delete ligaDescarga;
        }
});